export const state = {
  __isSaved: true,
  __isPublished: false,
  __isMakeDefault: false,
};
